var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "container ad-container mx-auto p-75" }, [
      _c(
        "ul",
        { staticClass: "d-flex flex-wrap justify-content-center mx--12px" },
        [
          _vm._l(_vm.adsToDisplay, function(ad) {
            return _c(
              "li",
              { staticClass: "card-wrapper m-12px" },
              [_c("cat-uxo-ad-template", { attrs: { ad: ad } })],
              1
            )
          }),
          _vm._v(" "),
          _vm._l(_vm.placeholders, function(i) {
            return _vm.placeholders
              ? _c(
                  "li",
                  {
                    staticClass:
                      "position-relative card-wrapper placeholder m-12px fs-12 text-uppercase d-flex justify-content-center align-items-center",
                    staticStyle: { "background-color": "#FFFFFF" }
                  },
                  [
                    _c("img", {
                      staticClass: "sizing-image",
                      attrs: { src: "/img/sizing@16x8.svg", alt: "" }
                    }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "sizing-image-overlay bg-white d-flex align-items-center justify-content-center",
                        attrs: { href: _vm.advertiseHere }
                      },
                      [_c("span", {}, [_vm._v("advertise here")])]
                    )
                  ]
                )
              : _vm._e()
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "headline mx-auto" }, [
      _c(
        "div",
        {
          staticClass:
            "headline-text position-relative text-uppercase fs-12 mx-auto"
        },
        [_vm._v("CAT-UXO COMMERCIAL MEMBERS")]
      )
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-392c49d8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-392c49d8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/shared/StackedAds.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-392c49d8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/shared/StackedAds.vue
// module chunks = 0 1